import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonCode: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      isCode: ctx.editor?.isActive("code") || false,
      canToggleCode: ctx.editor?.can().chain().toggleCode().run() ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().toggleCode().run()}
      disabled={!editorState.canToggleCode}
      active={editorState.isCode}
      icon="code"
      tooltip="Code"
    />
  );
};
